export default "__VITE_ASSET__CrRxaFlb__"